import { Navigate, Route, Routes } from "react-router-dom"

import { NAMES_ROUTES, PARAMS } from "@/const/routes.constants"
import { RecurringReportPage } from "./components/pages/RecurringReportPage"
import { DEFAULT_ROUTE, REPORT_TAB_PARAM } from "./const"
import { ReportsPage } from "./ReportsPage"

export const ReportsRoutes = () => {
  const { RECURRING } = NAMES_ROUTES.REPORTS
  const resource = "reports" as const

  return (
    <Routes>
      <Route path={`/:${REPORT_TAB_PARAM}`} element={<ReportsPage />} />
      <Route
        path={`/${RECURRING}/:${PARAMS.ID}/:${PARAMS.DUPLICATE_ID}?`}
        element={<RecurringReportPage resource={resource} />}
      />
      <Route path="*" element={<Navigate replace to={DEFAULT_ROUTE} />} />
    </Routes>
  )
}
